<template>
  <div>
    <mall-header></mall-header>
    <mall-bread>
        <span style="color:#999" to="/orderConfirm">确认订单信息</span>
    </mall-bread>
    <div class="orderConfirm-div" v-loading.fullscreen.lock="fullscreenLoading">
        <span class="orderConfirm-div-titel" >确认订单信息</span> 
          <table  class="orderConfirm-table">
              <tr class="orderConfirm-table-tr-head" >
                <td width="600px" style="    float: left;margin-left: -265px; margin-top: 7px;">商品</td>
                <td width="200px">单价</td>
                <td width="200px">数量</td>
                <td width="200px">小计</td>
              </tr>
              <tr class="orderConfirm-table-tr-content" v-for="(datas, i) in orderData.orderDetails" :key="i">
                <td >
                  <span  style="margin-left: 20px;">
                    <img :src="datas.itemImgUrl" @click="openGoodsDetails(datas.serviceItemId)" style="width: 68px;height: 68px;cursor: pointer;"/>
                  </span>
                  <span  class="orderConfirm-table-tr-span" @click="openGoodsDetails(datas.serviceItemId)">{{datas.supplierName}}</span>
                </td>
                <td style="    text-align: center;">￥{{datas.unitPrice}}</td>
                <td style="    text-align: center;">{{datas.quantity}}份</td>
                <td  class="orderConfirm-table-td" >￥{{datas.amount}}</td>
              </tr>
          </table>
          <div>
              <span class="orderConfirm-div-payType" >选择支付方式</span>
              <div class="orderConfirm-payType-div">
                <div :class="isSelectWX?wxpayInitDiv:wxpaySelectedDiv"  @click="selectWX()">
                     <svg :class="isSelectWX?wxpayInitImg:wxpaySelectedImg" aria-hidden="false">
                      <use fill="#4CAF50" xlink:href="#weixinzhifu"></use>
                    </svg> 
                    <!-- <img src="../../static/images/wxpay.png" :class="isSelectWX?wxpayInitImg:wxpaySelectedImg"  /> -->
                    <span :class="wxpayInitFont" >微信支付</span>
                    <img src="../../static/images/勾选.png"  v-if="!isSelectWX" style="      width: 12px;height: 8px;float: right;margin-top: 3px;margin-right: 3px;" />
                  </div>
                  <div  :class="isSelectali?alipayInitDiv:alipaySelectedDiv" @click="selectAli()">
                   <svg :class="isSelectali?alipayInitImg:alipaySelectedImg" aria-hidden="false">
                      <use fill="#2698E4" xlink:href="#zhifubaozhifu"></use>
                    </svg>
                    <!-- <img src="../../static/images/alipayLog.png"  :class="isSelectali?wxpayInitImg:wxpaySelectedImg" /> -->
                    <span  :class="alipayInitFont" style="    " >支付宝支付</span>
                    <img src="../../static/images/勾选.png"  v-if="!isSelectali" style="  width: 12px; height: 8px;float: right; margin-top: 3px;margin-right: 3px;" />
                  </div>
              </div>
          </div> 
          <div class="orderConfirm-yingfu-div" >
                <span  class="orderConfirm-yingfu-total" >应付总额：</span>
                <span class="orderConfirm-yingfu-money" >￥{{orderData.totalAmount}}</span>
                <button class="orderConfirm-yingfu-button" @click="nowPay" :disabled="isDisable" >立即支付</button>
          </div>
           <!-- <el-backtop   style="right: initial;bottom: 40px;">
                            <div class="el-backtop-div">
                              <img src="../../static/images/backtop.png" style="margin-top: 15px;" />
                            </div>
                        </el-backtop> -->
    </div>
    <div class="orderConfirm-foot-div" >
        <span class="orderConfirm-foot-remark" >说明</span>
       
        <span class="orderConfirm-foot-font" >购买过程中如您遇到任何问题，可随时与我们联系：</span>
        <span class="orderConfirm-foot-font" >1、拨打客服电话：400-788-5678 </span>
        <span  class="orderConfirm-foot-font">2、支付完成之后可在【我的订单>发票管理】开具发票</span>
    </div>
    <!-- <mall-footer style="margin-top:140px"></mall-footer> -->
     <div style="clear: both;height: 149px;">
      </div>
        <div style="left: 0px;bottom: 0px;width: 100%;z-index:1;text-align: center; padding: 20px 0;    color: #999999;font-size: 14px;">
      Copyright ©2021 深圳市东宝信息技术有限公司 All Rights Reserved
    </div>
     <!-- <el-backtop  :bottom="100" >
    <div
      style="
        height: 100%;
        width: 100%;
        box-shadow: 0 0 6px rgba(0,0,0, .12);
        text-align: center;
        line-height: 40px;
        color: #1989fa; ">
      <img src="../../static/images/backtop.png" style="      margin-top: 15px;width: 20px;height: 20px;"/>
    </div>
  </el-backtop> -->
  </div>
</template>
<script>
import "../assets/js/iconfont.js"
import mallHeader from '../components/header.vue'
import mallFooter from '../components/footer.vue'
import mallBread from '../components/navbread.vue'
import http from '../api/public'
import axios from 'axios'
  export default{
      data(){
          return{
            orderData:[],
            discount:13.2,
            shipPrice:0,
            freightRisk:5,
            mdShow:false,
            isSelectali : true,
            isSelectWX :false,
            selectType:0,
            fullscreenLoading:true,
            wxpayInitDiv:"wxpayInitDiv",
            wxpayInitImg:"wxpayInitImg",
            wxpayInitFont:"wxpayInitFont",
            wxpaySelectedDiv:"wxpaySelectedDiv",
            wxpaySelectedImg:"wxpaySelectedImg",
            wxpaySelectedFont:"wxpaySelectedFont",
            alipayInitDiv:"alipayInitDiv",
            alipayInitImg:"alipayInitImg",
            alipayInitFont:"alipayInitFont",
            alipaySelectedDiv:"alipaySelectedDiv",
            alipaySelectedImg:"alipaySelectedImg",
            alipaySelectedFont:"alipaySelectedFont",
            payShow:true,
            payC:false,
            payCtitle:'立即支付',
            isDisable:false,
            payType:'../../static/images/payali.png',
            payTitle:'打开支付宝'

          }
      },
      mounted() {
        this.getOrderData();
      },
      computed:{
        
      },
      methods: {
        //确认支付页面，订单信息查询展示
        getOrderData() {
          var oderId = this.$route.query.orderId;
          axios.get('/mallApi/mall/order/queryById?id='+oderId,{headers:{"token": localStorage.getItem("Authorization")}}).then((res) => {
            res = res.data;
           this.fullscreenLoading=false;
          if(res.success) {
            this.orderData = res.result;
            this.orderData.totalAmount = http.changeUnitPrice(this.orderData.totalAmount);
             console.log(this.orderData)
            this.orderData.orderDetails.forEach(da => {
              da.itemImgUrl =  "/mallApi"+da.itemImgUrl;
              da.amount = http.changeUnitPrice(da.amount);
              da.unitPrice = http.changeUnitPrice(da.unitPrice);
            });
              // this.$message({
              //   showClose: true,
              //   message: '操作成功！',
              //   type: 'success'
              // });
          }else{
            if(res.code == 401|| res.code == 400) {
              http.setLocalStorge();
              this.$router.push({path: '/login'});
            }else{
              //this.$message(res.message);
              this.$message({
                showClose: true,
                message: '操作失败！',
                type: 'error'
              });
            }
          }
            
          });
        },
        //选择微信支付
        selectWX(){
            this.isSelectWX =false;
            this.isSelectali = true;
        },
         //选择支付宝支付
        selectAli(){
            this.isSelectali = false;
            this.isSelectWX =true;
        },
        closeModal() {
          this.mdShow = false;
          this.payC = false;
          this.payCtitle = '立即支付';
        },
         //选择支付方式
        select(type) {
          this.selectType = type;
          if(type === 0) {
            this.payType = '../../static/images/payali.png';
            this.payTitle = '打开支付宝';
          } else {
            this.payType = '../../static/images/weixin.png';
            this.payTitle = '打开微信';
          }
        },
        //立即支付，选择支付方式
        nowPay(){
          if(this.isSelectWX && this.isSelectali){
               this.$message({
                    showClose: true,
                    message: '请选择支付方式！',
                  });
          }else{
              if(!this.isSelectWX){
                  this.$router.push({ path:'/wxPay' ,query:{"orderId":this.$route.query.orderId,"orderNo":this.orderData.orderNo}})
                  return
              }
              if(!this.isSelectali){
                  this.$router.push({ path:'/alipay',query:{"orderId":this.$route.query.orderId,"orderNo":this.orderData.orderNo} })
                  return
              }  
          }
          this.isDisable = true
          setTimeout(() => {
          this.isDisable = false
          }, 1000)
        },
        //订单商品详情
        openGoodsDetails(id){
            window.open("#/goodsDetails?id="+id);
        }
      },
      components: {
        mallHeader,
        mallBread,
        mallFooter
      }
  }
</script>
<style lang="stylus" rel="stylesheet/stylus">
  .orderConfirm-div{
    height: auto;
    background: #fff;
    box-shadow: 0px 2px 12px 0px rgba(0,0,0,0.02);
    overflow: auto;
    margin: 0 auto
    width: 1200px;
    min-width: 1200px; 
   
  }
  .orderConfirm-div-titel{
      height: 25px;
      font-size: 26px;
      font-family: PingFang SC;
      font-weight: bold;
      color: rgb(51, 51, 51);
      line-height: 20px;
      position: absolute;
      margin: 30px 30px 30px 30px;
  }
  .orderConfirm-table{
      width: 95%;
      height: auto;
      background: rgb(255, 255, 255);
      border: 1px solid rgb(238, 238, 238);
      margin: 30px 30px 40px 30px;
      float: left;
      margin-top: 75px;
  }
  .el-button--primary {
    color: #FFF;
    background-color: #287EFF;
    border-color: #287EFF;
  }
  .orderConfirm-table-tr-head{
      height: 40px;
      background: #F6F6F6;
      text-align: center;
  }
  .orderConfirm-table-tr-content{
      height: 110px;
      background: #FFFFFF;
      border: 1px solid #EEEEEE;
  }
  .orderConfirm-table-tr-span{
      margin: 25px;
      display: inline-block;
      vertical-align: top;
      cursor: pointer;
      font-size: 16px;
      font-family: PingFang SC;
      font-weight: bold;
      color: #333333;
  }
  .orderConfirm-table-td{
      text-align: center;
       height: 13px;
       font-size: 16px;
       font-family: PingFang SC;
       font-weight: bold;
       color: #FF620D;
       line-height: 20px;
  }
  .orderConfirm-div-payType{
      font-size: 16px;
      font-family: PingFang SC;
      font-weight: bold;
      color: rgb(51, 51, 51);
      line-height: 22px;
      margin-top: 0px;
      margin-left: 30px;
      float: left;
  }
  .orderConfirm-payType-div{
     margin: 30px 30px 20px 0px;
      float: left;
      margin-left: -125px;
      
  }
  .orderConfirm-payType-wximg{
      margin-top: -60px;
      border: 1px solid rgb(40, 126, 255);
      margin-left: 31px;
      width: 180px;
      height: 60px;
  }
  .orderConfirm-table-tr-span:hover{color: #287eff}
  .orderConfirm-payType-aliimg{
      margin-top: 20px;
      width: 180px;
      height: 60px;
      background: rgb(255, 255, 255);
      border: 1px solid rgb(238, 238, 238);
      margin-left: 20px;
  }
  .orderConfirm-yingfu-div{
      width: 95%;
      height: 80px;
      background: rgb(246, 246, 246);
      float: left;
      margin-left: 30px;
      margin-top: 0px;
      margin-bottom: 40px;
  }
  .orderConfirm-yingfu-total{
     position: absolute;
    margin-left: 780px;
    margin-top: 30px;
    height: 16px;
    font-size: 16px;
    font-family: PingFang SC;
    font-weight: bold;
    color: #333;
    line-height: 22px;
  }
  .orderConfirm-yingfu-money{
          position: absolute;
    margin-left:850px;
    margin-top: 30px;
    width: 67px;
    height: 20px;
    font-size: 26px;
    font-family: PingFang SC;
    font-weight: bold;
    color: #FF620D;
    line-height: 20px;
  }
  .orderConfirm-yingfu-button{
      width: 12%;
      height: 40px;
      background: #287EFF;
      border-radius: 4px;
      float: right;
      margin-right: 20px;
      margin-top: 20px;
      font-size: 16px;
      font-family: PingFang SC;
      font-weight: 500;
      color: #FFFFFF;
      line-height: 20px;
  }
  
.orderConfirm-yingfu-button:hover{ background: #428EFF;}
  orderConfirm-yingfu-button:active{
      background: #126BF0;
  }
  .orderConfirm-yingfu-button button:active {
    background: #126BF0;
}
  .orderConfirm-foot-remark{
      display: block;
      font-size: 16px;
      font-family: PingFang SC;
      font-weight: 800;
      color: #333333;
      line-height: 24px;
      margin-top: 20px;
  }
  .orderConfirm-foot-div {
    margin-top: 20px;
    height: 88px;
    margin: 0 auto;
    width: 1140px;
    min-width: 200px;
}
  .orderConfirm-foot-font{
      display: block;
      font-size: 14px;
      font-family: PingFang SC;
      color: #666666;
      line-height: 24px;
  }
  

	.alipaySelectedImg{
		 margin-left: 30px;
		margin-top: 19px;
    width: 24px;
    height: 24px;
	}
	.alipaySelectedFont{
		    font-size: 16px;
		font-family: PingFang SC;
		font-weight: 500;
		color: rgb(51, 51, 51);
		line-height: 22px;
		vertical-align: top;
		margin-top: 20px;
		margin-left: 5px;
	}
  .alipayInitDiv{
		margin-top: 20px;
    border: 1px solid #eee;
    margin-left: 230px;
    margin-top: -60px;
    float: right;
    width: 180px;
    height: 60px;
    cursor: pointer;
	}
	.alipaySelectedDiv {
    border: 1px solid #287eff;
    background: linear-gradient(225deg, transparent 20px, #fff 0px) #287eff;
    margin-left: 230px;
    margin-top: -60px;
    float: right;
    width: 180px;
    height: 60px;
    cursor: pointer;
	}
	.alipayInitImg{
		    margin-left: 30px;
    margin-top: 19px;
    width: 24px;
    height: 24px;
	}
	.alipayInitFont{
		   font-size: 16px;
    font-family: PingFang SC;
    font-weight: 500;
    color: #333;
    line-height: 22px;
    margin-top: 20px;
    margin-left: 5px;
    position: absolute;
	}
  .wxpaySelectedDiv{
    margin-top: 20px;
    border: 1px solid #287eff;
    margin-left: 30px;
    width: 180px;
    height: 60px;
    background: linear-gradient(225deg, transparent 20px, #fff 0px) #287eff;
    cursor: pointer;
	}
	
	.wxpaySelectedImg{
		margin-left: 30px;
    margin-top: 20px;
    width: 23px;
    height: 21px;
	}
	.wxpaySelectedFont{
		 font-size: 16px;
		font-family: PingFang SC;
		font-weight: 500;
		color: rgb(51, 51, 51);
		line-height: 22px;
		vertical-align: top;
		margin-top: 20px;
		margin-left: 5px;
	}
  .wxpayInitDiv{
		margin-top: 20px;
		border: 1px solid #EEEEEE;
		margin-left: 30px;
		width: 180px;
		height: 60px;
    cursor: pointer;
	}
	.wxpayInitImg{
		margin-left: 30px;
		margin-top: 15px;
    margin-left: 30px;
    margin-top: 20px;
    width: 23px;
    height: 21px;
	}
	.wxpayInitFont{
		font-size: 16px;
		font-family: PingFang SC;
		font-weight: 500;
		color: rgb(51, 51, 51);
		line-height: 22px;
		margin-top: 20px;
		margin-left: 5px;
		position: absolute;
	}
	.wxpaySelectedFont{
		 font-size: 16px;
		font-family: PingFang SC;
		font-weight: 500;
		color: rgb(51, 51, 51);
		line-height: 22px;
		vertical-align: top;
		margin-top: 20px;
		margin-left: 5px;
	}
	

</style>



// WEBPACK FOOTER //
// OrderConfirm.vue?7fb7ebe2